module.exports = __webpack_public_path__ + "static/media/plan-acumula-300gb.8bfccbf7.svg";